import { Helmet } from "react-helmet-async"
import { SharedRateSheetsList } from "../../../../RateSheets"
import { useOutletContext } from "../../../../router-utils"
import type { TSharedRateSheetsOutletContext } from "./_layout"

export default function SharedRateSheetsPage() {
	const { guestToken } = useOutletContext<TSharedRateSheetsOutletContext>()

	return (
		<>
			<Helmet>
				<title>B2B Rate Sheets</title>
			</Helmet>
			<SharedRateSheetsList guestToken={guestToken} />
		</>
	)
}
